import { defineStore } from "pinia";

export const useOrderStore = defineStore("order", {
    state: () => ({
        order: {
            name: "",
            company_name: "",
            email: "",
            phone: "",
            street_address: "",
            city: "",
            state: "",
            zip: "",
            items: []
        }
    }),

    getters: {
        totalItems: (state) => state.order.items.reduce((sum, i) => sum + i.quantity, 0),
        hasItems: (state) => state.order.items.length > 0,
    },

    actions: {
        addItem(item) {
            const existing = this.order.items.find(i => i.product_variant_id === item.product_variant_id);
            if (existing) {
                if(item.quantity)
                    existing.quantity += item.quantity;
            } else {
                this.order.items.push({ ...item, quantity: item.quantity || 1 });
            }
            this.saveToStorage();
        },

        updateQuantity(product_variant_id, qty) {
            const item = this.order.items.find(i => i.product_variant_id === product_variant_id);
            if (item) {
                item.quantity = qty;
                if (item.quantity <= 0) {
                    this.removeItem(product_variant_id);
                } else {
                    this.saveToStorage();
                }
            }
        },

        getItem(product_variant_id){
            const item = this.order.items.find(i => i.product_variant_id === product_variant_id);
            return item
        },

        removeItem(product_variant_id) {
            this.order.items = this.order.items.filter(i => i.product_variant_id !== product_variant_id);
            this.saveToStorage();
        },

        clearOrder() {
            this.order = { items: [] };
            localStorage.removeItem("order");
        },

        clearOrderItems(){
            this.order.items = []
            this.saveToStorage()
        },

        setCustomerInfo(customerInfo) {
            this.order.customer = { ...this.order.customer, ...customerInfo };
            this.saveToStorage();
        },

        saveToStorage() {
            localStorage.setItem("order", JSON.stringify(this.order));
        },

        loadFromStorage() {
            const saved = localStorage.getItem("order");
            if (saved) {
                this.order = JSON.parse(saved);
            }
        }
    }
});
